export type QualityLevel = 'low' | 'medium' | 'high';

export type QualitySettings = {
  level: QualityLevel;
  pixelRatioCap: number;
  postfx: {
    enabled: boolean;
    bloom: boolean;
    ssao: boolean;
    smaa: boolean;
  };
  shadows: {
    enabled: boolean;
    mapSize: number;
  };
  world: {
    buildingDetail: QualityLevel;
    trafficCount: number;
  };
};

export function detectQuality(): QualitySettings {
  const ua = navigator.userAgent || '';
  const isMobile = /Android|iPhone|iPad|iPod|Mobile/i.test(ua);
  const mem = (navigator as any).deviceMemory as number | undefined;
  const cores = navigator.hardwareConcurrency || 4;

  let level: QualityLevel = 'high';
  if (isMobile) level = 'medium';
  if ((mem && mem <= 4) || cores <= 4) level = isMobile ? 'low' : 'medium';

  if (level === 'high') {
    return {
      level,
      pixelRatioCap: 2,
      postfx: { enabled: true, bloom: true, ssao: true, smaa: true },
      shadows: { enabled: true, mapSize: 2048 },
      world: { buildingDetail: 'high', trafficCount: 18 }
    };
  }
  if (level === 'medium') {
    return {
      level,
      pixelRatioCap: 1.5,
      postfx: { enabled: true, bloom: true, ssao: false, smaa: true },
      shadows: { enabled: true, mapSize: 1024 },
      world: { buildingDetail: 'medium', trafficCount: 10 }
    };
  }
  return {
    level: 'low',
    pixelRatioCap: 1.2,
    postfx: { enabled: true, bloom: false, ssao: false, smaa: false },
    shadows: { enabled: false, mapSize: 512 },
    world: { buildingDetail: 'low', trafficCount: 6 }
  };
}
